/**
 * Incorporation Entity Feature Routes
 */

import type { RouteRecordRaw } from 'vue-router';

export const setupEntityRoutes: RouteRecordRaw[] = [
    {
        path: '/setup-entity',
        name: 'SetUpEntityList',
        component: () => import('./views/SetUpEntityListPage.vue'),
        meta: {
            title: 'Incorporation Entity',
            titleKey: 'setupEntity.Incorporation Entity',
            requiresAuth: true,
            layout: 'default',
        },
    },
    // 더 구체적인 경로를 먼저 배치 (라우터 매칭 순서)
    {
        path: '/setup-entity/application',
        name: 'IncorporationApplicationPublic',
        component: () => import('./views/IncorporationApplicationPage.vue'),
        meta: {
            title: 'Incorporation Application',
            titleKey: 'setupEntity.Incorporation Application',
            requiresAuth: false,
            layout: 'blank',
        },
    },
    {
        path: '/setup-entity/create',
        name: 'IncorporationApplication',
        component: () => import('./views/IncorporationApplicationPage.vue'),
        meta: {
            title: 'Incorporation Application',
            titleKey: 'setupEntity.Incorporation Application',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/setup-entity/detail/:icpCd',
        name: 'IncorporationDetail',
        component: () => import('./views/IncorporationDetailPage.vue'),
        meta: {
            title: 'Incorporation Detail',
            titleKey: 'setupEntity.Incorporation Detail',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/setup-entity/due-diligence/:cddCd?',
        name: 'DueDiligenceDetail',
        component: () => import('./views/DueDiligenceDetailPage.vue'),
        meta: {
            title: 'Due Diligence',
            titleKey: 'setupEntity.Due Diligence',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/setup-entity/multi-officer-due-diligence/:icpCd',
        name: 'MultiOfficerDueDiligence',
        component: () => import('./views/MultiOfficerDueDiligencePage.vue'),
        meta: {
            title: 'Due Diligence',
            titleKey: 'setupEntity.Due Diligence',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/setup-entity/due-diligence-public/:cddCd?',
        name: 'DueDiligenceDetailPublic',
        component: () => import('./views/DueDiligenceDetailPage.vue'),
        meta: {
            title: 'Due Diligence',
            titleKey: 'setupEntity.Due Diligence',
            requiresAuth: false,
            layout: 'blank',
        },
    },
    {
        path: '/setup-entity/custom-form/create',
        name: 'CustomFormCreate',
        component: () => import('./views/CustomFormBuilderPage.vue'),
        meta: {
            title: 'New Custom Form',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/setup-entity/custom-form/:formCd',
        name: 'CustomFormEdit',
        component: () => import('./views/CustomFormBuilderPage.vue'),
        meta: {
            title: 'Edit Custom Form',
            requiresAuth: true,
            layout: 'default',
        },
    },
    // Public form fill page (accessed via deep link)
    {
        path: '/custom-form/fill/:formCd?',
        name: 'CustomFormFillPublic',
        component: () => import('./views/CustomFormFillPage.vue'),
        meta: {
            title: 'Custom Form',
            requiresAuth: false,
            layout: 'blank',
        },
    },
    // Authenticated preview (same page, in-app layout)
    {
        path: '/setup-entity/custom-form/:formCd/preview',
        name: 'CustomFormFillPreview',
        component: () => import('./views/CustomFormFillPage.vue'),
        meta: {
            title: 'Custom Form Preview',
            requiresAuth: true,
            layout: 'default',
        },
    },
    // Responses viewer (submissions received for a given form)
    {
        path: '/setup-entity/custom-form/:formCd/responses',
        name: 'CustomFormResponses',
        component: () => import('./views/CustomFormResponsesPage.vue'),
        meta: {
            title: 'Custom Form Responses',
            requiresAuth: true,
            layout: 'default',
        },
    },
];

export default setupEntityRoutes;
